module.exports = __webpack_public_path__ + "img/4.fe8d39d3.jpg";